'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES = 'Yes';
var NO = 'No';
var YESF_NOV = 'Yes fruit, but no vegetables';
var YESV_NOF = 'Yes vegetables, but no fruit';

var Module3App4 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module3,
    profile: state.profile.data,
    app: state.moduleData.data.module3.app4
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module3App4, _Component);

  function Module3App4() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module3App4);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module3App4.__proto__ || (0, _getPrototypeOf2.default)(Module3App4)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 3,
      appId: 4,
      isCompleted: _this.props.app.isCompleted || false,
      title: 'Mealtime Strategies - Feeding',
      doesChildSeeYouEat: _this.props.app.doesChildSeeYouEat || '',
      doYouTeach: _this.props.app.doYouTeach || '',
      whatITell: _this.props.app.whatITell || '',
      seeTrustedCaregivers: _this.props.app.seeTrustedCaregivers || '',
      whatSayToChild: _this.props.app.whatSayToChild || ''
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.handledoesChildSeeYouEat = function (event) {
      var obj = _this.state;
      obj.doesChildSeeYouEat = event.target.value;
      obj.doYouTeach = '';
      obj.whatITell = '';
      obj.seeTrustedCaregivers = '';
      obj.whatSayToChild = '';
      _this.setState(obj);
    }, _this.handledoYouTeach = function (event) {
      var obj = _this.state;
      obj.doYouTeach = event.target.value;
      obj.whatITell = '';
      obj.seeTrustedCaregivers = '';
      obj.whatSayToChild = '';
      _this.setState(obj);
    }, _this.handleSeeTrustedCaregivers = function (event) {
      var obj = _this.state;
      obj.seeTrustedCaregivers = event.target.value;
      obj.whatSayToChild = '';
      _this.setState(obj);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleOnClick = function (module, modtype, item, event) {
      console.log(event);
      _this.props.changeItem(module, modtype, item, 0);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module3App4, [{
    key: 'getHimHer',


    /*
     * Returns him/her depending on child gender
     */
    value: function getHimHer() {
      if (this.props.profile.childGender === 'Male') {
        return 'him';
      }

      if (this.props.profile.childGender === 'Female') {
        return 'her';
      }

      return 'them';
    }

    /*
     * Returns he/she depending on child gender
     */

  }, {
    key: 'getHeShe',
    value: function getHeShe() {
      if (this.props.profile.childGender === 'Male') {
        return 'he';
      }

      if (this.props.profile.childGender === 'Female') {
        return 'she';
      }

      return 'he/she';
    }

    /*
     * Handle when user finishes this module
     */


    /*
     * User types in something for what was
     * involved in the diet
     */


    /* *************** */
    /* HANDLE ON CLICK */
    /* *************** */

    // used to navigate to a resource item

  }, {
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');
      var img1 = require('../Assets/img1.jpeg');
      var img2 = require('../Assets/img2.jpeg');
      var img3 = require('../Assets/img3.jpeg');
      var pizza = require('../Assets/pizza.jpg');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 3'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, sm: 12, xs: 12 },
              _react2.default.createElement(
                'p',
                null,
                'Let\'s look at some specific strategies to encourage ',
                this.props.profile.childName,
                ' to eat the foods you provide. As we look at them, think about any of the strategies you might like to try before the next module.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'By "encourage" we still mean acting within your role in the P\'s and C\'s. So we are talking about doing positive things that still allow your child to choose \'what\', \'if\' and \'how much\' to eat.'
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 8, sm: 8, xs: 8 },
              _react2.default.createElement(
                'h3',
                null,
                'Strategy 1: Consistent providing and offering of fruit and vegetables regardless of the outcome'
              ),
              _react2.default.createElement(
                'p',
                null,
                'We talked about this last week. This is still one of the most successful ways to increase childrens\' vegetable intake long-term.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  { className: styles.orangeText },
                  'Remember on average, it takes up to 20 offers'
                ),
                ' before a child will accept a new food.'
              ),
              _react2.default.createElement(
                'h3',
                null,
                'Strategy 2: Be a positive role model'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Role modelling healthy eating is one of the best things you can do to encourage your child to eat vegetables and continue to eat vegetables over the long-term'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'One of the best ways to role model is to eat and enjoy lots of fruit and vegetables yourself and using positive language to describe them'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Childhood is a critical time for establishing food preferences, but also an age when kids are cautious of new foods. They learn what is safe to eat by watching adults'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Pretend that mashed potato is \'potato glue\' which other vegies love sticking to. Kids can dip spoons of mash into other vegies such as peas, corn and carrot. Turn a simple pita bread pizza into a fun Mr Vegie face by arranging pizza toppings to make eyes, nose, mouth and ears'
                  )
                )
              ),
              _react2.default.createElement('div', { className: styles.spacer20 }),
              _react2.default.createElement(ReactBootstrap.Image, { src: pizza, responsive: true }),
              _react2.default.createElement('div', { className: styles.spacer20 }),
              _react2.default.createElement(
                'h4',
                null,
                'Does your child see you eat lots of fruit and vegetables?'
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handledoesChildSeeYouEat.bind(this) },
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'doesChildSeeYouEat', value: YES, checked: this.state.doesChildSeeYouEat === YES },
                  YES
                ),
                this.state.doesChildSeeYouEat === YES && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    'Excellent. To further encourage ',
                    this.props.profile.childName,
                    ' to eat fruit and vegies you could teach them about them and explain why they are good to eat.'
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'doesChildSeeYouEat', value: NO, checked: this.state.doesChildSeeYouEat === NO },
                  NO
                ),
                this.state.doesChildSeeYouEat === NO && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    'Again, the more ',
                    this.props.profile.childName,
                    ' sees you eat fruit and vegies, the more likely that ',
                    this.getHeShe(),
                    ' will eat them. To further encourage ',
                    this.props.profile.childName,
                    ' to eat fruit and vegetables you could teach them about ',
                    this.getHimHer(),
                    ' and explain why they are good to eat.'
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'doesChildSeeYouEat', value: YESF_NOV, checked: this.state.doesChildSeeYouEat === YESF_NOV },
                  YESF_NOV
                ),
                this.state.doesChildSeeYouEat === YESF_NOV && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    'That\'s great that you eat lots of fruits in front of your child. It would be even better if ',
                    this.getHeShe(),
                    ' can see you eating lots of vegies also. The more ',
                    this.props.profile.childName,
                    ' sees you eat vegetables, the more likely ',
                    this.props.profile.childName,
                    ' will eat them. To encourage ',
                    this.getHimHer(),
                    ' to eat fruit and vegetables you could teach ',
                    this.getHimHer(),
                    ' about them and explain why they are good to eat.'
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'doesChildSeeYouEat', value: YESV_NOF, checked: this.state.doesChildSeeYouEat === YESV_NOF },
                  YESV_NOF
                ),
                this.state.doesChildSeeYouEat === YESV_NOF && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    'That\'s great that you eat lots of vegies in front of your child. It would be even better if they can see you eating lots of fruit also. The more ',
                    this.props.profile.childName,
                    ' sees you eat fruit, the more likely that they will eat it too. To encourage ',
                    this.props.profile.childName,
                    ' to eat fruit and vegetables you could teach them about them and explain why they are good to eat.'
                  )
                )
              ),
              this.state.doesChildSeeYouEat === YES && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'Do you ever tell them things like this?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handledoYouTeach.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'doYouTeach', value: YES, checked: this.state.doYouTeach === YES || this.state.doYouTeach == 1 },
                    YES
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'doYouTeach', value: NO, checked: this.state.doYouTeach === NO || this.state.doYouTeach == 0 },
                    NO
                  )
                )
              ),
              (this.state.doYouTeach === YES || this.state.doYouTeach == 1) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'What sort of things do you tell them about fruit and vegetables?'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text',
                  placeholder: 'What I tell them about fruit and veges', value: this.state.whatITell, onChange: this.handleChange.bind(this, 'whatITell') }),
                _react2.default.createElement('br', null)
              ),
              (this.state.whatITell || this.state.doesChildSeeYouEat !== YES && this.state.doesChildSeeYouEat !== '') && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h4',
                  null,
                  'What about other caregivers? Do they see any other trusted adults eating fruits and vegetables?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleSeeTrustedCaregivers.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'seeTrustedCaregivers', value: YES, checked: this.state.seeTrustedCaregivers === YES || this.state.seeTrustedCaregivers == 1 },
                    YES
                  ),
                  (this.state.seeTrustedCaregivers === YES || this.state.seeTrustedCaregivers == 1) && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'It\'s great that ',
                      this.props.profile.childName,
                      ' has some role models eating fruit and vegetables. As mentioned, the more ',
                      this.props.profile.childName,
                      ' sees adults eating vegetables, the more likely ',
                      this.getHeShe(),
                      ' will be to eat them.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'seeTrustedCaregivers', value: NO, checked: this.state.seeTrustedCaregivers === NO || this.state.seeTrustedCaregivers == 0 },
                    NO
                  ),
                  (this.state.seeTrustedCaregivers === NO || this.state.seeTrustedCaregivers == 0) && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'It\'s not easy when other caregivers do not help you role model healthy eating in front of your child. Perhaps you could explain to the other caregivers about how important role modelling is for your child, and most importantly keep going yourself.'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 4, sm: 4, xs: 4 },
              _react2.default.createElement(ReactBootstrap.Image, { src: img1, responsive: true }),
              _react2.default.createElement('div', { className: styles.spacer40 }),
              _react2.default.createElement(ReactBootstrap.Image, { src: img2, responsive: true })
            ),
            (this.state.seeTrustedCaregivers || this.state.seeTrustedCaregivers == 0) && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 8, xs: 8, sm: 8 },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Strategy 3: Use verbal praise and encouragement'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  'Can you please tell me about what you say to ',
                  this.props.profile.childName,
                  ' to encourage ',
                  this.props.profile.childName,
                  ' to eat vegetables at mealtimes?'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Think about the things you said at your last meal.'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text',
                  placeholder: 'How I encourage my child', value: this.state.whatSayToChild, onChange: this.handleChange.bind(this, 'whatSayToChild') }),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'p',
                  null,
                  'Praise is about noticing the times when ',
                  this.props.profile.childName,
                  ' is displaying good behaviour. It only has to be a sentence explaining that you are pleased with ',
                  this.getHimHer(),
                  '. This might include praising ',
                  this.props.profile.childName,
                  ' for sitting at the table, commenting on how yummy ',
                  _react2.default.createElement(
                    'u',
                    null,
                    'your'
                  ),
                  ' meal is, and making nicknames for foods.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'Praise example:'
                  ),
                  ' What a good boy for sitting at the table or trying some food!'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Encouragement'
                  ),
                  ' is also important. It is about promoting fruit and vegetables without putting pressure on',
                  this.props.profile.childName,
                  '. Provide just a little, encourage ',
                  this.props.profile.childName,
                  ' to taste it and let ',
                  this.getHimHer(),
                  ' spit it out if they want to.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'Encouragement example:'
                  ),
                  ' Yum, this corn is really juicy!'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'It\'s quite common for parents to pressure or offer other food rewards (eg. dessert) to their children when they\'re not eating, however according to the P\'s and C\'s framework, this is going beyond the parent\'s role.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Module 3 resources provides more suggestions for providing praise.'
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 4, xs: 4, sm: 4 },
                _react2.default.createElement(ReactBootstrap.Image, { src: img3, responsive: true })
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, sm: 12, xs: 12 },
              _react2.default.createElement('div', { className: styles.spacer20 }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
              ),
              _react2.default.createElement('div', { className: styles.spacer100 })
            )
          )
        )
      );
    }
  }]);
  return Module3App4;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  profile: _propTypes2.default.object,
  module: _propTypes2.default.number,
  modtype: _propTypes2.default.number,
  item: _propTypes2.default.number,
  changeItem: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = Module3App4;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/3/App/App4.js
// module id = 1199
// module chunks = 0